import type { selectedDate } from 'types/interfaces';
import type { TaskEmployeeDistributionCardProps } from 'types/props';

export type DistributionMode = 'all' | 'travelTime';

type DistributionVariant = NonNullable<
  TaskEmployeeDistributionCardProps['variant']
>;

const STORAGE_KEYS: Record<DistributionVariant, string> = {
  tasks: 'taskEmployeeDistributionMode',
  calendarAssignments: 'calendarAssignmentsEmployeeDistributionMode'
};

export function readDistributionMode(
  variant: DistributionVariant
): DistributionMode {
  try {
    const stored = localStorage.getItem(STORAGE_KEYS[variant]);
    return stored === 'travelTime' ? 'travelTime' : 'all';
  } catch {
    return 'all';
  }
}

export function persistDistributionMode(
  variant: DistributionVariant,
  mode: DistributionMode
) {
  try {
    localStorage.setItem(STORAGE_KEYS[variant], mode);
  } catch {}
}

export function getDayDateFilter(date: Date): selectedDate {
  const start = new Date(date);
  start.setHours(0, 0, 0, 0);

  const end = new Date(date);
  end.setHours(23, 59, 59, 999);

  return {
    dateFrom: String(start.getTime()),
    dateUntil: String(end.getTime())
  };
}

export function getTomorrowDateFilter(now = new Date()): selectedDate {
  const tomorrow = new Date(now);
  tomorrow.setDate(tomorrow.getDate() + 1);
  return getDayDateFilter(tomorrow);
}

export function getSingleDayApiDate(dateFilter: selectedDate): string {
  const raw = dateFilter?.dateFrom;
  if (raw === undefined || raw === null || raw === '') return '';

  const date = new Date(Number(raw));
  if (isNaN(date.getTime())) return '';

  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
}
